// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"261a9a21","785":"715d8022"}[chunkId] + ".chunk.js";
};